/* eslint-disable @repo/internal/react/require-jsdoc */
import React, { ReactNode } from 'react';

import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import { Anchor, Inline, xcss } from '@atlaskit/primitives';

const styles = xcss({
	width: 'fit-content',
	font: 'font.body.large',
	textDecorationThickness: '1px',
	textUnderlineOffset: '2px',
	':hover': {
		textDecorationThickness: '2px',
	},
});

const appearanceStylesMap = {
	default: xcss({
		color: 'color.text',
		':hover': {
			color: 'color.text',
		},
	}),
	inverse: xcss({
		color: 'color.text.inverse',
		':hover': {
			color: 'color.text.inverse',
		},
	}),
};

export const LinkWithArrow = ({
	href,
	appearance = 'default',
	children,
}: {
	href: string;
	appearance?: 'inverse' | 'default';
	children: ReactNode;
}) => {
	return (
		<Anchor xcss={[styles, appearanceStylesMap[appearance]]} href={href}>
			<Inline alignBlock="center" space="space.050">
				{children}
				<ArrowRightIcon color="currentColor" LEGACY_size="small" label="" />
			</Inline>
		</Anchor>
	);
};
